import DriverProfile from './DriverProfile';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config';
import io from 'socket.io-client';

import { useAuth } from '../context/AuthContext';

const S = {
  app:       { display:'flex', minHeight:'100vh', background:'#f0f2f5', fontFamily:'sans-serif', direction:'rtl' },
  sidebar:   { width:'220px', minWidth:'220px', background:'linear-gradient(180deg,#1a1a2e,#16213e)', display:'flex', flexDirection:'column' },
  sideTop:   { padding:'24px 16px', borderBottom:'1px solid rgba(255,255,255,0.1)', textAlign:'center' },
  sideLogo:  { fontSize:'36px', marginBottom:'6px' },
  sideName:  { color:'#f1f5f9', fontWeight:'bold', fontSize:'14px', margin:'0 0 2px' },
  sideUser:  { color:'rgba(255,255,255,0.4)', fontSize:'12px', margin:0 },
  nav:       { flex:1, padding:'12px' },
  navBtn:    { display:'flex', alignItems:'center', gap:'10px', width:'100%', padding:'11px 14px', background:'none', border:'none', color:'rgba(255,255,255,0.6)', borderRadius:'8px', cursor:'pointer', fontSize:'14px', marginBottom:'2px', textAlign:'right' },
  navActive: { background:'rgba(255,255,255,0.15)', color:'#fff', fontWeight:'bold' },
  navIcon:   { fontSize:'18px', minWidth:'22px' },
  logoutBtn: { margin:'12px', padding:'10px', background:'rgba(239,68,68,0.15)', border:'1px solid rgba(239,68,68,0.3)', color:'#fca5a5', borderRadius:'8px', cursor:'pointer', fontSize:'13px' },
  main:      { flex:1, overflowY:'auto', padding:'24px' },
  pageTitle: { fontSize:'22px', fontWeight:'900', color:'#1a1a2e', margin:'0 0 4px' },
  pageSub:   { color:'#888', fontSize:'14px', margin:'0 0 20px' },
  grid3:     { display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'16px', marginBottom:'24px' },
  statCard:  { background:'#fff', borderRadius:'12px', padding:'20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' },
  statIcon:  { fontSize:'28px', marginBottom:'8px' },
  statNum:   { fontSize:'26px', fontWeight:'900', color:'#1a1a2e', margin:'0 0 4px' },
  statLabel: { fontSize:'13px', color:'#888' },
  card:      { background:'#fff', borderRadius:'12px', overflow:'hidden', boxShadow:'0 2px 8px rgba(0,0,0,0.06)', marginBottom:'20px' },
  cardHeader:{ padding:'16px 20px', borderBottom:'1px solid #f0f0f0', display:'flex', justifyContent:'space-between', alignItems:'center' },
  cardTitle: { fontWeight:'bold', fontSize:'16px', color:'#1a1a2e', margin:0 },
  addBtn:    { padding:'8px 16px', background:'linear-gradient(135deg,#1a1a2e,#0f3460)', border:'none', borderRadius:'8px', color:'#fff', fontSize:'13px', fontWeight:'bold', cursor:'pointer' },
  table:     { width:'100%', borderCollapse:'collapse' },
  th:        { padding:'12px 16px', textAlign:'right', fontSize:'12px', color:'#888', fontWeight:'bold', borderBottom:'1px solid #f0f0f0', background:'#fafafa' },
  td:        { padding:'12px 16px', fontSize:'13px', color:'#333', borderBottom:'1px solid #f8f8f8' },
  badge:     (c) => ({ padding:'3px 10px', borderRadius:'20px', fontSize:'12px', fontWeight:'bold', background:c+'22', color:c }),
  empty:     { textAlign:'center', padding:'40px', color:'#aaa' },
  modal:     { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999, padding:'20px' },
  modalBox:  { background:'#fff', borderRadius:'16px', padding:'24px', width:'100%', maxWidth:'460px', maxHeight:'90vh', overflowY:'auto' },
  modalTitle:{ fontSize:'18px', fontWeight:'bold', color:'#1a1a2e', margin:'0 0 20px', display:'flex', justifyContent:'space-between' },
  field:     { marginBottom:'14px' },
  label:     { display:'block', fontSize:'13px', color:'#555', marginBottom:'5px', fontWeight:'bold' },
  input:     { width:'100%', padding:'11px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', boxSizing:'border-box', outline:'none' },
  select:    { width:'100%', padding:'11px', border:'1px solid #ddd', borderRadius:'8px', fontSize:'14px', boxSizing:'border-box', outline:'none', background:'#fff' },
  submitBtn: { width:'100%', padding:'13px', background:'linear-gradient(135deg,#1a1a2e,#0f3460)', border:'none', borderRadius:'10px', color:'#fff', fontSize:'15px', fontWeight:'bold', cursor:'pointer', marginTop:'8px' },
  errBox:    { background:'#fff5f5', border:'1px solid #ffcccc', borderRadius:'8px', padding:'10px', color:'#e74c3c', fontSize:'13px', marginBottom:'12px' },
  sucBox:    { background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:'8px', padding:'10px', color:'#16a34a', fontSize:'13px', marginBottom:'12px' },
};

const ST_COLOR = { approved:'#22c55e', pending:'#f59e0b', rejected:'#ef4444', suspended:'#94a3b8', online:'#22c55e', offline:'#94a3b8', busy:'#f59e0b', delivered:'#22c55e', failed:'#ef4444', in_transit:'#8b5cf6', accepted:'#3b82f6', searching:'#f59e0b', cancelled:'#ef4444' };
const ST_AR   = { approved:'معتمد', pending:'قيد المراجعة', rejected:'مرفوض', suspended:'موقوف', online:'متاح', offline:'غير متاح', busy:'مشغول', delivered:'تم التسليم', failed:'فشل', in_transit:'في الطريق', accepted:'تم القبول', searching:'بحث', cancelled:'ملغي' };

export default function Dashboard() {
  const { user, company, logout } = useAuth();
  const [page,    setPage]    = useState('home');
  const [drivers, setDrivers] = useState([]);
  const [orders,  setOrders]  = useState([]);
  const [stats,   setStats]   = useState(null);
  const [companyInfo, setCompanyInfo] = useState(null);
  const [modal,   setModal]   = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [driverOrders, setDriverOrders] = useState([]);
  const [form,    setForm]    = useState({});
  const [err,     setErr]     = useState('');
  const [suc,     setSuc]     = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!company?.id) return;
    axios.get(`${API}/companies/${company.id}`).then(r => setCompanyInfo(r.data.company));
    axios.get(`${API}/companies/${company.id}/stats`).then(r => setStats(r.data.stats));
  }, [company]);

  useEffect(() => {
    if (page === 'drivers') axios.get(`${API}/drivers`).then(r => setDrivers(r.data.drivers || []));
    if (page === 'orders')  axios.get(`${API}/orders`).then(r => setOrders(r.data.orders));
  }, [page]);

  const openModal = () => { setModal(true); setForm({}); setErr(''); setSuc(''); };
  const closeModal = () => { setModal(false); setErr(''); setSuc(''); };

  const addDriver = async e => {
    e.preventDefault(); setErr(''); setSuc(''); setLoading(true);
    try {
      await axios.post(`${API}/drivers`, { ...form, company_id: company.id });
      setSuc('✅ تم إضافة الطيار بنجاح. سيتم مراجعته من الإدارة.');
      setForm({});
      axios.get(`${API}/drivers`).then(r => setDrivers(r.data.drivers));
    } catch(e) { setErr(e.response?.data?.error || 'حصل خطأ'); }
    finally { setLoading(false); }
  };

  const openDriverProfile = (d) => { setSelectedDriver(d); axios.get(`${API}/orders?driver_id=${d.id}`).then(r => setDriverOrders(r.data.orders || [])).catch(()=>{}); };



  if (selectedDriver) return <DriverProfile driver={selectedDriver} token={localStorage.getItem('co_token')} onBack={()=>setSelectedDriver(null)} />;
  const navItems = [['home','🏠','الرئيسية'],['drivers','🛵','الطيارين'],['orders','📦','الطلبات']];

  return (
    <div style={S.app}>
      <div style={S.sidebar}>
        <div style={S.sideTop}>
          <div style={S.sideLogo}>🏢</div>
          <p style={S.sideName}>{companyInfo?.name || company?.name || 'شركتي'}</p>
          <p style={S.sideUser}>{user?.full_name}</p>
        </div>
        <nav style={S.nav}>
          {navItems.map(([id,ic,lb]) => (
            <button key={id} style={{...S.navBtn,...(page===id?S.navActive:{})}} onClick={()=>setPage(id)}>
              <span style={S.navIcon}>{ic}</span><span>{lb}</span>
            </button>
          ))}
        </nav>
        <button style={S.logoutBtn} onClick={logout}>🚪 تسجيل الخروج</button>
      </div>

      <div style={S.main}>
        {page === 'home' && (
          <>
            <div style={S.pageTitle}>لوحة التحكم</div>
            <div style={S.pageSub}>أهلاً {user?.full_name}!</div>
            <div style={S.grid3}>
              <div style={S.statCard}><div style={S.statIcon}>📦</div><div style={S.statNum}>{stats?.completed_orders||0}</div><div style={S.statLabel}>رحلة مكتملة</div></div>
              <div style={S.statCard}><div style={S.statIcon}>💰</div><div style={S.statNum}>{parseFloat(stats?.total_earned||0).toFixed(0)} ج</div><div style={S.statLabel}>إجمالي الأرباح</div></div>
              <div style={S.statCard}><div style={S.statIcon}>🛵</div><div style={S.statNum}>{drivers.length||0}</div><div style={S.statLabel}>طيار مسجل</div></div>
            </div>
            {companyInfo && (
              <div style={S.card}>
                <div style={S.cardHeader}><h3 style={S.cardTitle}>معلومات الشركة</h3></div>
                <div style={{padding:'16px'}}>
                  {[['الاسم',companyInfo.name],['الإيميل',companyInfo.email],['الهاتف',companyInfo.phone],['نسبة المنصة',companyInfo.platform_fee_pct+'%'],['حالة الاشتراك',companyInfo.subscription_paid?'✅ مدفوع':'❌ غير مدفوع']].map(([l,v])=>(
                    <div key={l} style={{display:'flex',justifyContent:'space-between',padding:'10px 0',borderBottom:'1px solid #f5f5f5',fontSize:'14px'}}>
                      <span style={{color:'#888'}}>{l}</span><span style={{fontWeight:'bold',color:'#1a1a2e'}}>{v}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}

        {page === 'drivers' && (
          <>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'16px'}}>
              <div><div style={S.pageTitle}>الطيارين</div><div style={S.pageSub}>{drivers.length} طيار مسجل</div></div>
              <button style={S.addBtn} onClick={openModal}>+ إضافة طيار</button>
            </div>
            <div style={S.card}>
              <table style={S.table}>
                <thead><tr>{['الاسم','الهاتف','المركبة','اللوحة','الحالة','التوفر','الرحلات','التقييم'].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {drivers.map(d=>(
                    <tr key={d.id} onClick={()=>setSelectedDriver(d)} style={{cursor:'pointer'}}>
                      <td style={S.td}>{d.full_name}</td>
                      <td style={S.td}>{d.phone}</td>
                      <td style={S.td}>{d.vehicle_type||'—'}</td>
                      <td style={S.td}>{d.vehicle_plate||'—'}</td>
                      <td style={S.td}><span style={S.badge(ST_COLOR[d.status]||'#94a3b8')}>{ST_AR[d.status]||d.status}</span></td>
                      <td style={S.td}><span style={S.badge(ST_COLOR[d.availability]||'#94a3b8')}>{ST_AR[d.availability]||d.availability}</span></td>
                      <td style={S.td}><button onClick={async()=>{try{const sus=!d.company_suspended;await axios.patch(`${API}/drivers/${d.id}/company-suspend`,{suspended:sus});axios.get(`${API}/drivers`,{headers:{Authorization:`Bearer ${localStorage.getItem('co_token')}`}}).then(r=>setDrivers(r.data.drivers||[]));}catch(e){alert(e.response?.data?.error||'حصل خطأ');}}} style={{padding:'4px 10px',background:d.company_suspended?'#22c55e':'#ef4444',color:'#fff',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px'}}>{d.company_suspended?'تفعيل':'ايقاف'}</button></td>
                      <td style={S.td}>{d.total_trips}</td>
                      <td style={S.td}>{d.avg_rating||'—'} ⭐</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {drivers.length===0 && <div style={S.empty}>لا يوجد طيارين. اضغط "إضافة طيار" للبدء.</div>}
            </div>
          </>
        )}

        {page === 'orders' && (
          <>
            <div style={S.pageTitle}>الطلبات</div>
            <div style={S.pageSub}>{orders.length} طلب</div>
            <div style={S.card}>
              <table style={S.table}>
                <thead><tr>{['العميل','الطيار','من','إلى','السعر','نصيبكم','الحالة','ملغي بواسطة','التاريخ'].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {orders.map(o=>(
                    <tr key={o.id}>
                      <td style={S.td}>{o.client_name}</td>
                      <td style={S.td}>{o.driver_name||'—'}</td>
                      <td style={{...S.td,maxWidth:'120px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{o.pickup_address}</td>
                      <td style={{...S.td,maxWidth:'120px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{o.dropoff_address}</td>
                      <td style={S.td}>{o.base_price} ج</td>
                      <td style={S.td}>{o.company_amount||'—'} ج</td>
                      <td style={S.td}><span style={S.badge(ST_COLOR[o.status]||'#94a3b8')}>{ST_AR[o.status]||o.status}</span></td>
                      <td style={S.td}>{o.status==='cancelled' ? (o.cancelled_by_name||'—') : '—'}</td>
                      <td style={S.td}>{new Date(o.requested_at).toLocaleDateString('ar-EG')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {orders.length===0 && <div style={S.empty}>لا توجد طلبات بعد.</div>}
            </div>
          </>
        )}
      </div>

      {selectedDriver && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999,padding:'20px'}} onClick={e=>e.target===e.currentTarget&&setSelectedDriver(null)}>
          <div style={{background:'#fff',borderRadius:'16px',padding:'24px',width:'100%',maxWidth:'460px',maxHeight:'90vh',overflowY:'auto'}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:'16px'}}>
              <span style={{fontSize:'18px',fontWeight:'bold'}}>&#x1F6F5; {selectedDriver.full_name}</span>
              <button onClick={()=>setSelectedDriver(null)} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer'}}>X</button>
            </div>
            <div style={{background:'linear-gradient(135deg,#667eea,#764ba2)',borderRadius:'12px',padding:'16px',color:'#fff',textAlign:'center',marginBottom:'16px'}}>
              <p style={{margin:'0 0 4px',fontSize:'13px',opacity:0.8}}>التقييم العام</p>
              <p style={{margin:'0 0 4px',fontSize:'36px',fontWeight:'bold'}}>&#x2B50; {selectedDriver.avg_rating||'جديد'}</p>
              <p style={{margin:0,fontSize:'13px',opacity:0.8}}>{selectedDriver.total_trips||0} رحلة</p>
            </div>
            <div style={{marginBottom:'16px'}}>
              {[['الهاتف',selectedDriver.phone],['المركبة',selectedDriver.vehicle_type],['اللوحة',selectedDriver.vehicle_plate]].map(([l,v])=>(
                <div key={l} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid #f0f0f0',fontSize:'14px'}}>
                  <span style={{color:'#666'}}>{l}</span>
                  <span style={{fontWeight:'bold'}}>{v||'—'}</span>
                </div>
              ))}
            </div>
            <h4 style={{margin:'0 0 12px'}}>آخر الرحلات</h4>
            {driverOrders.length===0 ? <p style={{color:'#888',textAlign:'center',padding:'20px'}}>لا توجد رحلات</p> : driverOrders.slice(0,10).map(o=>(
              <div key={o.id} style={{background:'#f8f9ff',borderRadius:'10px',padding:'12px',marginBottom:'8px'}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:'4px'}}>
                  <span style={{fontSize:'13px',fontWeight:'bold'}}>{(o.pickup_address||'').substring(0,25)}...</span>
                  <span style={{fontSize:'12px',color:o.status==='delivered'?'#10b981':'#ef4444',fontWeight:'bold'}}>{o.status==='delivered'?'مكتمل':'ملغي'}</span>
                </div>
                <div style={{display:'flex',justifyContent:'space-between'}}>
                  <span style={{fontSize:'12px',color:'#888'}}>{new Date(o.requested_at).toLocaleDateString('ar-EG')}</span>
                  <span style={{fontSize:'12px',color:'#667eea',fontWeight:'bold'}}>{o.base_price} ج</span>
                  {o.client_rating&&<span style={{fontSize:'12px',color:'#f59e0b'}}>{o.client_rating}/5 &#x2B50;</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {modal && (
        <div style={S.modal} onClick={e=>e.target===e.currentTarget&&closeModal()}>
          <div style={S.modalBox}>
            <div style={S.modalTitle}>
              <span>إضافة طيار جديد</span>
              <button onClick={closeModal} style={{background:'none',border:'none',fontSize:'20px',cursor:'pointer',color:'#888'}}>✕</button>
            </div>
            {err && <div style={S.errBox}>{err}</div>}
            {suc && <div style={S.sucBox}>{suc}</div>}
            {!suc && (
              <form onSubmit={addDriver}>
                {[['full_name','الاسم كامل','text'],['phone','رقم الهاتف','tel'],['password','كلمة المرور','password'],['national_id','رقم الهوية','text'],['license_number','رقم الرخصة','text'],['vehicle_plate','رقم اللوحة','text']].map(([k,lb,tp])=>(
                  <div key={k} style={S.field}>
                    <label style={S.label}>{lb}</label>
                    <input style={S.input} type={tp} value={form[k]||''} onChange={e=>setForm({...form,[k]:e.target.value})} required={['full_name','phone','password'].includes(k)}/>
                  </div>
                ))}
                <div style={S.field}>
                  <label style={S.label}>نوع المركبة</label>
                  <select style={S.select} value={form.vehicle_type||'دراجة نارية'} onChange={e=>setForm({...form,vehicle_type:e.target.value})}>
                    {['دراجة نارية','سيارة','توك توك','دراجة عادية'].map(v=><option key={v}>{v}</option>)}
                  </select>
                </div>
                <button style={S.submitBtn} type="submit" disabled={loading}>{loading?'⏳ جاري...':'إضافة الطيار'}</button>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
